var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserPlus = function SvgUserPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 14.224a4.367 4.367 0 0 1 4.364 4.365v1.882a.6.6 0 1 1-1.2 0V18.59A3.165 3.165 0 0 0 12 15.423H6.352a3.166 3.166 0 0 0-3.165 3.166v1.882a.6.6 0 1 1-1.2 0V18.59a4.365 4.365 0 0 1 4.365-4.365zm6.588-6.589a.6.6 0 0 1 .6.6v2.225h2.224a.6.6 0 1 1 0 1.199h-2.224v2.223a.6.6 0 1 1-1.2 0V11.66h-2.223a.6.6 0 1 1 0-1.2h2.223V8.236a.6.6 0 0 1 .6-.6M9.176 2.93a4.365 4.365 0 1 1 0 8.73 4.365 4.365 0 0 1 0-8.73m0 1.2a3.166 3.166 0 1 0 .001 6.33 3.166 3.166 0 0 0-.001-6.33"
  })));
};
export default SvgUserPlus;